import { render, staticRenderFns } from "./cardAgrupacionInforme.vue?vue&type=template&id=922b1afc&"
import script from "./cardAgrupacionInforme.vue?vue&type=script&lang=js&"
export * from "./cardAgrupacionInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports